import { render, staticRenderFns } from "./multi_tag.vue?vue&type=template&id=75bd500a&scoped=true&"
import script from "./multi_tag.vue?vue&type=script&lang=js&"
export * from "./multi_tag.vue?vue&type=script&lang=js&"
import style0 from "./multi_tag.vue?vue&type=style&index=0&id=75bd500a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75bd500a",
  null
  
)

export default component.exports